module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-view",
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._t("default", [(_vm.hasImage) ? _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": " ",
      "src": _vm.url
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasPdf) ? [_c('object', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "data": _vm.url,
      "type": _vm.type
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n                alt: "), _c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("Open")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "grey lighten-1 mb-3",
      "width": 150
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("Open")])] : _vm._e()])], 2), _vm._v(" "), (_vm.dialogVisible) ? _c('div', {
    staticClass: "simple-dialog",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "centered",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.hasImage) ? _c('div', {
    staticStyle: {
      "max-height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "top",
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": " ",
      "src": _vm.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasPdf) ? _c('object', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%%",
      "width": "800px",
      "height": "800px"
    },
    attrs: {
      "data": _vm.url,
      "type": "application/pdf"
    }
  }, [_vm._v("\n                alt: "), _c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("Open")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hover-bar"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "border-right": "solid 1px #555"
    }
  }, [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                    New Tab\n                ")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("\n                    Close\n                ")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c816eff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DocumentView.vue
// module id = 2492
// module chunks = 1